<template>
  <div class="modal-field">
    <button class="modal-field__close-btn" @click="closeModal">
      <BaseIcon name="cross" />
    </button>
    <h1 class="modal-field__title" v-html="title"></h1>
    <FormField
      class="modal-field__form modals-container__scroll-content"
      @input="collectForm"
      :scope="modalData.scope"
      :parent="modalData.parent"
      :forbiddenKeys="modalData.usedKeys"
      :showKeyHint="modalData.scope !== 'customobjectsgroups'"
    ></FormField>
    <div class="modal-field__buttons">
      <BaseButton title="Cancel" @click.native="closeModal"/>
      <BaseButton title="Add" @click.native="handleSubmit" theme="primary"/>
    </div>
  </div>
</template>

<script>
  import FormField from '@/components/forms/FormField'
  import { MDSModalNewFieldModel } from '@/models/modal-datasets.model'

  export default {
    components: {
      FormField
    },
    props: {
      modalData: MDSModalNewFieldModel
    },
    data () {
      return {
        title: null,
        form: null
      }
    },
    methods: {
      closeModal () {
        this.$store.commit('modals/CLOSE_LAST_MODAL')
      },
      async handleSubmit () {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          console.warn('Invalid form')
          return
        }

        if ( this.form.type === 'repeater_json' ) {
          this.form.type = 'repeater'
          this.form.subType = 'repeater_json'
        }

        this.$eventBus.$emit('ModalNewField/ADD_NEW_FIELD', { field: this.form, parent: this.modalData.parent })
        this.closeModal()
      },
      setTitle () {
        const { label } = this.modalData.parent
        this.title = `Add a field ${label ? `to <strong>${label}</strong>` : ''}`
      },
      collectForm (form) {
        this.form = form
      },
      handleKeyEvent (e) {
        // Dont add ENTER listener, for now enter is reservered for textarea to make newline!!!
        // if (e.keyCode === 13) {
        //   this.handleSubmit()
        // }
      },
    },
    created () {
      this.setTitle()
    },
    mounted () {
      document.addEventListener('keydown', this.handleKeyEvent)
    },
    beforeDestroy () {
      document.removeEventListener('keydown', this.handleKeyEvent)
    }
  }
</script>

<style lang="scss" src="./modal-field.scss"></style>



// WEBPACK FOOTER //
// src/components/modals/modals-content/ModalNewField.vue